import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { properties } from '../../utils/Properties_es';

export default function SuccessForm({  data}) {
    const {id: idTransaction } = useParams();

  

    
   return (
    <Container className="py-5" style={{ backgroundColor: '#f4f4f4', minHeight: '100vh' }}>
      <Card className="shadow-sm border-0 mx-auto p-4" style={{ maxWidth: '800px', borderRadius: '15px' }}>
        <h4 className="fw-bold mb-4">{properties.success_title}</h4>
        
        <Row className="g-3">
          {/* Ubicación */}
          <Col md={6}>
            <div className="d-flex align-items-center p-3 border rounded bg-white">
              <i className="bi bi-geo-alt text-primary fs-4 me-3"></i>
              <div>
                <div className="fw-bold">{data.commerce.address}</div>
                <small  style={{textTransform:'capitalize'}}>{data.commerce.provinceName} {data.commerce.cantonName}  {data.commerce.distritoName} {data.commerce.barrioName}</small>
              </div>
            </div>
          </Col>

          {/* Persona */}
          <Col md={6}>
            <div className="d-flex align-items-center p-3 border rounded bg-white">
              <i className="bi bi-person text-primary fs-4 me-3"></i>
              <div>
                <div className="fw-bold">{data.commerce.nameReceive}</div>
                <small className="text-muted">{properties.success_receiver}</small>
              </div>
            </div>
          </Col>

          {/* Cuenta */}
          <Col md={6}>
            <div className="d-flex align-items-center p-3 border rounded bg-white">
              <i className="bi bi-credit-card text-primary fs-4 me-3"></i>
              <div>
                <div className="fw-bold">{data.costs.moneda!="AMBO"?data.costs.cuentaSeleccionadaCRC!=""?data.costs.cuentaSeleccionadaCRC:data.costs.cuentaSeleccionadaUSD: data.costs.cuentaSeleccionadaCRC+" / "+data.costs.cuentaSeleccionadaUSD}</div>
                <small className="text-muted">{properties.success_account}</small>
              </div>
            </div>
          </Col>

          {/* Moneda */}
          <Col md={6}>
            <div className="d-flex align-items-center p-3 border rounded bg-white">
              <i className="bi bi-currency-dollar text-primary fs-4 me-3"></i>
              <div>
                <div className="fw-bold">{data.costs.moneda==="AMBO" ? properties.success_currency_both : data.costs.moneda}</div>
                <small className="text-muted">{properties.success_currency_label}</small>
              </div>
            </div>
          </Col>
        </Row>

        {/* Sección Siguientes Pasos */}
        <div className="mt-5 p-4 rounded" style={{ backgroundColor: '#f8f9fa' }}>
          <h5 className="fw-bold mb-3">{properties.success_next_steps}</h5>
          <div className="d-flex align-items-start p-3 bg-white border-start border-info border-4 shadow-sm">
            <i className="bi bi-info-circle-fill text-info fs-4 me-3"></i>
            <p className="mb-0 text-muted">
              {properties.success_next_steps_detail}
            </p>
          </div>
        </div>

        {/* Botón Final */}
        <div className="d-flex justify-content-end mt-4">
          <Button 
            variant="primary" 
            className="px-5 py-2 fw-bold"
            as={Link} 
            to={`/portal-web/${idTransaction}`}
          >
            {properties.btn_done}
          </Button>
        </div>
      </Card>
    </Container>
  );
};